/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import { Button, Icon } from 'semantic-ui-react'
import { useTranslation } from 'react-i18next'
import { useSaveFulfillment } from './useSaveFulfillment'
import React, { useContext, useState } from 'react'
import { AdjustWeight } from './AdjustWeight'
import { UltyModalWrapperContext } from '../../../../Shared/UltyModalWrapper/UltyModalWrapperContext'
import { AdjustQuantityOrWeight } from './OrderItemFulfillmentIssueBar/AdjustQuantityOrWeight'
import { useScheduledOrderPrecheck } from './useScheduledOrderPrecheck'

const FoundItemButton = ({order, orderItem}) => {
    const [t] = useTranslation()
    const {foundItemMutation, isPendingFulfillment} = useSaveFulfillment(order.id, orderItem.id)
    const {handleUltyModalWrapper} = useContext(UltyModalWrapperContext)
    const [displayAdjustmentComponent, setDisplayAdjustmentComponent] = useState(false)
    const {withScheduledOrderPrecheck} = useScheduledOrderPrecheck(order)

    const showAdjustWeightModal = () => {
        const modalSettings = {
            size: 'tiny',
            component: <AdjustWeight
              order={order}
              platformModule={order.platform.module}
              orderItem={orderItem}
              pickingMethod='MANUAL'
              onSubmit={() => {
                  handleUltyModalWrapper(false, null)
              }}
            />,
        }

        handleUltyModalWrapper(true, modalSettings)
    }

    const handleOnFoundItemClick = () => {
        const isItemPricedByCount = !orderItem.item || !orderItem.item.pricedByUnit || orderItem.item.pricedByUnit.type === 'COUNT'
        if (isItemPricedByCount) {
            if (orderItem.fulfillmentIssue === 'OUT_OF_ITEM') {
                // let the user adjust the weight or quantity of the item to re-add in the order
                setDisplayAdjustmentComponent(true)
            } else {
                withScheduledOrderPrecheck(() => {
                    foundItemMutation.mutate({orderItem, pickingMethod: 'MANUAL'})
                })()
            }
        } else {
            showAdjustWeightModal()
        }
    }

    if (!displayAdjustmentComponent) {
        return (
          <Button
            labelPosition="right"
            icon
            color="green"
            loading={isPendingFulfillment}
            onClick={handleOnFoundItemClick}
          >
              {t('order.fulfillment.item_found', { count: (orderItem.sellableUnit?.type === 'COUNT' && !['OUT_OF_ITEM', 'SUBSTITUTION'].includes(orderItem.fulfillmentIssue)) ?
                    orderItem.quantity :
                    undefined })}
              <Icon name="shop"/>
          </Button>
        )
    }

    return (
      <div
        css={css`
            display: flex;
            justify-content: space-between;
        `}
      >
          <Button
            icon
            color="green"
            onClick={() => setDisplayAdjustmentComponent(false)}
          >
              <Icon name="arrow left"/>
          </Button>
          <AdjustQuantityOrWeight
            order={order}
            orderItem={orderItem}
            fulfillmentReplacement={orderItem.fulfillmentReplacement}
            onSubmit={() => setDisplayAdjustmentComponent(false)}
          />
      </div>
    )
}

export { FoundItemButton }
